import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Instagram, Facebook, Twitter, Clock } from 'lucide-react';
import Header from './components/Header9';
import Footer from './components/Footer9';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Contact = () => {
    const [formData, setFormData] = useState({
        name: '', email: '', phone: '', subject: '', message: '',
    });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        devLog('Contact form submitted:', formData);
    };

    const contactInfo = [
        { icon: Mail, label: 'Email', value: 'hello@naksha.in', href: 'mailto:hello@naksha.in' },
        { icon: Phone, label: 'Phone', value: '+91 80 1234 5678', href: 'tel:+918012345678' },
        { icon: MapPin, label: 'Address', value: '42 MG Road, Indiranagar, Bangalore 560038' },
        { icon: Clock, label: 'Hours', value: 'Mon - Sat: 10 AM - 7 PM IST' },
    ];

    const inputClass = "w-full px-4 py-3 text-sm border border-[#E2E8F0] rounded-none focus:outline-none focus:border-[#2563EB] bg-white text-[#0F172A] placeholder-[#94A3B8]";

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="pt-20 md:pt-24 pb-8 bg-[#F8FAFC] border-b border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-0.5 bg-[#2563EB]" />
                        <p className="text-xs tracking-[0.3em] uppercase text-[#2563EB] font-medium">Get in Touch</p>
                    </div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A]">Contact Us</h1>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
                    {/* Contact Info */}
                    <div className="lg:col-span-2">
                        <h2 className="text-lg font-semibold text-[#0F172A] mb-2 uppercase tracking-wider">Contact Information</h2>
                        <div className="w-8 h-0.5 bg-[#2563EB] mb-6" />
                        <p className="text-sm text-[#64748B] leading-relaxed mb-8 font-light">
                            Have a question about our collections, sizing, or orders? We would love to hear from you. Our team is available to assist.
                        </p>

                        <div className="space-y-6">
                            {contactInfo.map((info, idx) => (
                                <div key={idx} className="flex gap-4">
                                    <div className="w-10 h-10 flex items-center justify-center bg-[#F8FAFC] border border-[#E2E8F0] rounded-none flex-shrink-0">
                                        <info.icon size={18} className="text-[#2563EB]" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-1">{info.label}</p>
                                        {info.href ? (
                                            <a href={info.href} className="text-sm text-[#64748B] hover:text-[#2563EB] transition-colors font-light">
                                                {info.value}
                                            </a>
                                        ) : (
                                            <p className="text-sm text-[#64748B] font-light">{info.value}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Social */}
                        <div className="mt-8 pt-8 border-t border-[#E2E8F0]">
                            <p className="text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-4">Follow Us</p>
                            <div className="flex gap-3">
                                {[Instagram, Facebook, Twitter].map((Icon, idx) => (
                                    <a
                                        key={idx}
                                        href="#"
                                        className="w-10 h-10 flex items-center justify-center border border-[#E2E8F0] rounded-none text-[#64748B] hover:text-[#2563EB] hover:border-[#2563EB] transition-colors duration-300"
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="lg:col-span-3">
                        <div className="bg-white border border-[#E2E8F0] rounded-none p-6 sm:p-8 relative">
                            <div className="absolute top-0 left-0 w-1 h-full bg-[#2563EB]" />
                            <h2 className="text-lg font-semibold text-[#0F172A] mb-6 uppercase tracking-wider">Send us a Message</h2>
                            <div className="w-8 h-0.5 bg-[#2563EB] mb-6" />

                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Name</label>
                                        <input name="name" value={formData.name} onChange={handleChange} placeholder="Your name" required className={inputClass} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Email</label>
                                        <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" required className={inputClass} />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Phone</label>
                                        <input name="phone" type="tel" value={formData.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" className={inputClass} />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Subject</label>
                                        <input name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" required className={inputClass} />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Message</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Tell us more..."
                                        required
                                        rows={5}
                                        className={`${inputClass} resize-none`}
                                    />
                                </div>
                                <Button variant="primary" size="lg" type="submit" icon={Send}>
                                    Send Message
                                </Button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Contact;
